import { CommentsState } from "./comments-state.interface";

export const createCommentsState = (): CommentsState => ({
  loading: false,
  errors: null,
  searchResults: null,
});
